module.exports = __webpack_public_path__ + "assets/b9c9d65c3192824c7b5212c9c118f28d.mp3";